import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path d="M12 16.5L6.12215 20.5902L8.19577 13.7361L2.48943 9.40983L9.64886 9.26393L12 2.5L14.3511 9.26393L21.5106 9.40983L15.8042 13.7361L17.8779 20.5902L12 16.5Z" />,
  'Star',
)
